// src/constants/dataTypes.js

export const repFormats = {
  OZW: 'OZW' ,
  REP_DE: 'REP German',
  REP_EN: 'REP English',
  REP_FR: 'REP French'
}



// export const fwdDataTypes = [
//   { value: 'DMReadout', label: 'Meter readout' },
//   { value: 'DMScan', label: 'Meter scan' },
//   { value: 'QnodeReadout', label: 'Network readout' },
//   { value: 'QnodeScan', label: 'Network scan' },
//   { value: 'CustomerReport', label: 'Report' }
// ];
